export default __webpack_public_path__ + "img/sagoo/sagoo5_480.webp";